import React from 'react';
import { makeStyles } from '@material-ui/core';
import ReactHtmlParser from 'react-html-parser';

const useStyles = makeStyles(() => ({
  content: {
    whiteSpace: 'pre-line',
  },
}));

const CommonPreview = ({
  content: {
    content,
  },
}) => {
  const classes = useStyles();
  return (
    <div className={classes.content}>
      {ReactHtmlParser(content)}
    </div>
  );
};

export default CommonPreview;
